import { render, staticRenderFns } from "./ProductNavigator.vue?vue&type=template&id=069351ab&scoped=true"
import script from "./ProductNavigator.vue?vue&type=script&lang=js"
export * from "./ProductNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069351ab",
  null
  
)

export default component.exports